import React, { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Bell, BellOff } from 'lucide-react';
import { toast } from 'sonner';
import { pushSupported, getPushSubscription, subscribeToPush, unsubscribeFromPush } from '@/lib/push';

export function PushBellButton() {
  const [enabled, setEnabled] = useState(false);
  const [busy, setBusy] = useState(false);
  const supported = pushSupported();

  useEffect(() => {
    if (!supported) return;
    getPushSubscription().then((s) => setEnabled(!!s)).catch(() => {});
  }, [supported]);

  if (!supported) return null;

  const toggle = async () => {
    setBusy(true);
    try {
      if (enabled) {
        await unsubscribeFromPush();
        setEnabled(false);
        toast.success('Live alerts off');
      } else {
        await subscribeToPush();
        setEnabled(true);
        toast.success("You'll get an alert when someone goes live 🔴");
      }
    } catch (e) {
      toast.error(e?.message || 'Could not update notifications');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      variant="ghost" size="icon" onClick={toggle} disabled={busy}
      className={enabled ? 'rounded-full text-[#F6B24A] hover:bg-[#F6B24A]/10' : 'rounded-full text-white/60 hover:bg-white/10'}
      title={enabled ? 'Live alerts on' : 'Get notified when someone goes live'}
      data-testid="push-bell-button"
    >
      {enabled ? <Bell className="h-5 w-5" /> : <BellOff className="h-5 w-5" />}
    </Button>
  );
}
